module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://assets.shoppersdrugmart.ca/bb-react-frontend/production-sdui/latest/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["beautyFrontendPlp"]) {
      return resolve(window.remoteLoading["beautyFrontendPlp"])
    }

    var res, rej;
    window.remoteLoading["beautyFrontendPlp"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["beautyFrontendPlp"] !== 'undefined') {
      res(window["beautyFrontendPlp"]);
      return resolve(window["beautyFrontendPlp"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["beautyFrontendPlp"] !== 'undefined') {
          res(window["beautyFrontendPlp"]);
          return resolve(window["beautyFrontendPlp"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "beautyFrontendPlp"
    );
  }).then(function () {
    const proxy = {
      get: beautyFrontendPlp.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          beautyFrontendPlp.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        beautyFrontendPlp.__initialized = true
      }
    }
    if (!beautyFrontendPlp.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });